export const formatBpm = (bpm: number | null): string =>
  bpm === null ? 'No BPM' : `${Number.isInteger(bpm) ? bpm.toFixed(0) : bpm.toFixed(1)} BPM`

